<template>
  <div @click.stop @mousedown.stop class="w-full flex flex-col flex-1 p-3">
    <div class="relative">
      <div class="absolute pin-t pin-r">
        <button class="bg-grey rounded-full w-6 h-6 flex justify-center" @click="dismiss">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    <ul v-if="tiles.length" class="list-reset flex-1 mt-8">
      <li v-for="(tile, index) in tiles" :key="index" class="mb-5 mt-2 flex justify-between">
        {{ tile.name }}
        <button @click="addTile(tile)" class="bg-blue text-white py-1 px-2 rounded">Add</button>
      </li>
    </ul>

    <loader v-else></loader>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import http from '@/http'
import { EventBus } from '@/EventBus'

export default {
  components: {
    Loader
  },

  data () {
    return {
      show: true,
      tiles: []
    }
  },

  created () {
    this.fetchAvailableTiles()
  },

  methods: {
    fetchAvailableTiles () {
      http.get('/tiles/list').then(res => {
        this.tiles = res.data
      })
    },

    addTile (tile) {
      http.post('/tiles/add', {
        tileId: tile.id
      }).then(res => {
        this.dismiss()
      })
    },

    dismiss (data) {
      EventBus.$emit('tile-selector:dismiss')
    }
  }
}
</script>

<style lang="sass" scoped>
  .h-200
    height: 200px

  .tile-selector
    width: 250px
    height: 200px
    border: 1px solid grey
    cursor: default

  .with-tooltip
    &::after, &::before
      content: ''
      width: 0
      height: 0

      position: absolute

      left: 50%
      bottom: -8px
      transform: translateX(-50%)

      border-right: 8px solid transparent
      border-left: 8px solid transparent

      border-top: 8px solid white

    &::before
      bottom: -9px
      border-top: 8px solid grey
</style>
